const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

const SHEET_IDS = {
  leadOutcome: '14y5irY0f3d94VMjGINABCO6u_vnfvlVOqQBpXK1y2PE',
  spend: '1qSHniDgSJBte_yKK8CMeqL0iVnIw2dY0SpdAZmwbQaA',
  callRail: '1C8jVy_q11MT_tZlKKfcguQcq-oyUMglHEbL5GNmVBTE',
  speedToLead: '1hFGB8-D4o_ZTAN_8YFLQmrfN6pFHhvu6euRo_TBQW-8',
};

async function fetchSheet(sheetId, range = 'Sheet1') {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${encodeURIComponent(range)}?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) {
    const errText = await res.text();
    console.error(`Sheet fetch error for ${sheetId}:`, errText);
    throw new Error(`Failed to fetch sheet: ${res.status}`);
  }
  const data = await res.json();
  const rows = data.values || [];
  if (rows.length < 2) return [];
  const headers = rows[0].map(h => h.trim());
  return rows.slice(1).map(row => {
    const obj = {};
    headers.forEach((h, i) => {
      obj[h] = row[i] || '';
    });
    return obj;
  });
}

export async function fetchLeadOutcome() {
  return fetchSheet(SHEET_IDS.leadOutcome);
}

export async function fetchSpend() {
  return fetchSheet(SHEET_IDS.spend);
}

export async function fetchCallRail() {
  return fetchSheet(SHEET_IDS.callRail);
}

export async function fetchSpeedToLead() {
  return fetchSheet(SHEET_IDS.speedToLead);
}

export async function fetchAllData() {
  const [leadOutcome, spend, callRail, speedToLead] = await Promise.all([
    fetchLeadOutcome(),
    fetchSpend(),
    fetchCallRail(),
    fetchSpeedToLead(),
  ]);
  return { leadOutcome, spend, callRail, speedToLead };
}